<template>
<div :id="wrapperId" class="position-relative">
    <div class="d-flex">
        <div v-if="no_lookup != true" class="pr-2 lookupBtnWrap">
            <btn v-show="!addressLookupShow" variant="outline-primary" @click="addressLookupToggle" title="Address Lookup"><i class="fal fa-search-location"></i></btn>
        </div>
        <f-set cssClass="w-75-px pr-2" :value="value.unit" @input="updateValue($event,'unit')" :data="c_fields.unit"/>
        <f-set cssClass="flex-grow-1 pr-2" :value="value.address" @input="updateValue($event,'address')" :data="c_fields.address"/>
        <f-set cssClass="w-125-px pr-2" :value="value.city" @input="updateValue($event,'city')" :data="c_fields.city"/>
        <f-set cssClass="w-100-px pr-2" :value="value.province" @input="updateValue($event,'province')" :data="c_fields.province"/>
        <f-set cssClass="w-85-px" :value="value.postal" @input="updateValue($event,'postal')" :data="c_fields.postal"/>
    </div>
    <div v-show="addressLookupShow" class="addressLookupWrap w-100 pt-2">
        <vue-google-autocomplete
                id="addressLookupField"
                ref="addressLookupField"
                classname="form-control"
                placeholder="Address Lookup" 
                @placechanged="getAddressData" 
                @blur="addressLookupToggle(false)"
                @keypress.enter="$event.preventDefault()"
                country="ca">
        </vue-google-autocomplete>
    </div>
</div>
    
</template>

<script>

import Vue from 'vue'
import fieldBuilder from '@/mixins/fieldBuilder'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
    components: { VueGoogleAutocomplete },
    mixins: [fieldBuilder],
    props: ['value','no_lookup','fields'],
    data() {
        return {
            wrapperId: 'address-lookup-' + new Date().getTime(),
            addressLookupShow: false,
            d_fields: {
                unit: this.makeField({ name: 'unit', label: 'Unit' }),
                address: this.makeField({ name: 'address', label: 'Address' }),
                city: this.makeField({ name: 'city', label: 'City' }),
                province: this.makeField({ name: 'province', label: 'Province' }),
                postal: this.makeField({ name: 'postal', label: 'Postal' }),
            },
            d_values: {
                hash: this.value.hash,
                unit: this.value.unit,
                address: this.value.address,
                city: this.value.city,
                province: this.value.province,
                postal: this.value.postal
            }
        }
    },
    computed: {
        c_fields() {
            return typeof(this.fields) !== 'undefined' ? this.fields : this.d_fields;
        }
    },
    methods: {
        updateValue(val, field) {
            this.d_values[field] = val;
            this.$emit('input', this.d_values)
        },
        addressLookupToggle(setVal) {
            this.addressLookupShow = typeof(setVal) !== 'undefined' ? setVal : !this.addressLookupShow;
            if (this.addressLookupShow) {
                window.setTimeout( () => this.$refs.addressLookupField.focus() , 100);         
            } else {
                this.$refs.addressLookupField.clear()
            } 
        },

        getAddressData: function (data, placeResultData, id) {
            var street_num = data.street_number ? data.street_number + ' ' : '';
            // document.getElementById(id).value = '';
            this.d_values.unit = '';
            this.d_values.address = street_num + data.route;
            this.d_values.city = data.locality;
            this.d_values.province = data.administrative_area_level_1;
            this.d_values.postal = data.postal_code;
            this.$emit('input', this.d_values)
            
            if (this.addressLookupShow) this.addressLookupToggle()
        }
    },
    mounted() {
        this.$emit('input', this.d_values) // this line is so not empty string is returned, but at least an object
    }
}
</script>

<style scoped>

.lookupBtnWrap {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    width: 55px;
}
.addressLookupWrap {
    position: absolute;
}
</style>